/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from 'react'
import { TFunction, useTranslation } from 'react-i18next'
import { view } from 'react-easy-state'
import { useNavigate } from 'react-router-dom'
import { Text, Radio, RadioGroup, Stack, useDisclosure } from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import { HiLocationMarker } from 'react-icons/hi'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import dayjs from 'dayjs'

import newNotifyStore from '../../core/stores/Viriyah/newNotifyStore'
import FormItem from '../../components/generics/FormItem'
import ButtonChakra from '../../components/generics/ButtonChakra'
import ModalGoogleMap from '../../components/generics/map/ModalGoogleMap'
import AlertError from '../../components/generics/AlertError'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Bangkok')

interface AppointmentClaimFormState {
  errorMessage: string
  incidentLocationRadio: string
  incidentLocation: string
  samePositionAccident: string
  incidentLandmark: string
  incidentLocationLng: string
  incidentLocationLat: string
}

const validationSchema = (t: TFunction<'translation', undefined>) => {
  return yup.object().shape({
    incidentLocationRadio: yup.string().required(t('viriyah.validate-message.make-claim.incidentLocationRadio')),
    samePositionAccident: yup.string(),
    incidentLocation: yup
      .string()
      .test('incidentLocationRadio', t('viriyah.validate-message.make-claim.incidentLocation'), function (value) {
        const { incidentLocationRadio } = this.parent
        if (incidentLocationRadio === 'newIncidentLocation') return value !== ''
        return true
      }),
    incidentLandmark: yup.string()
  })
}

export default view(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors }
  } = useForm<AppointmentClaimFormState>({
    defaultValues: {
      incidentLocationRadio: '',
      incidentLocation: '',
      samePositionAccident: newNotifyStore.accidentPlace,
      incidentLandmark: '',
      errorMessage: '',
      incidentLocationLng: '',
      incidentLocationLat: ''
    },
    resolver: yupResolver(validationSchema(t))
  })
  console.log('🚀 ~ file: AppointmentClaimInformation.tsx ~ line 48 ~ view ~ watch', watch())

  const onSubmit: SubmitHandler<AppointmentClaimFormState> = data => {
    const { incidentLocationRadio, incidentLandmark, incidentLocationLng, incidentLocationLat, incidentLocation } =
      watch()

    try {
      const pathName = 'addNewNotify'
      let appointmentPlaceOther;

      if(incidentLocationRadio === 'incidentLocation') {
        appointmentPlaceOther = newNotifyStore.accidentPlaceOther.length === 0 ? '-' : newNotifyStore.accidentPlaceOther
      } else {
        appointmentPlaceOther = incidentLandmark.length === 0 ? '-' : incidentLandmark
      }

      const payload = {
        notifyDate: Date(),
        notifyChannel: newNotifyStore.notifyChannel,
        accidentDateTime: newNotifyStore.accidentDateTime,
        accidentPlace: newNotifyStore.accidentPlace,
        accidentPlaceOther: newNotifyStore.accidentPlaceOther.length === 0 ? '-' : newNotifyStore.accidentPlaceOther ,//incidentLandmark.length === 0 ? '-' : incidentLandmark * ระบุจุดสังเกตของสถานที่ *
        latitude: newNotifyStore.latitude,
        longitude: newNotifyStore.longitude,
        driverPreName: newNotifyStore.driverPreName,
        driverFName: newNotifyStore.driverFName,
        driverLName: newNotifyStore.driverLName,
        driverPhone: newNotifyStore.driverPhone,
        notifyPreName: newNotifyStore.notifyPreName,
        notifyFName: newNotifyStore.notifyFName,
        notifyLName: newNotifyStore.notifyLName,
        notifyPhone: newNotifyStore.notifyPhone,
        insureCarLicense: newNotifyStore.insureCarLicense,
        insureCarLicenseProvince: newNotifyStore.insureCarLicenseProvince,
        vmiPolicyNumber: newNotifyStore.vmiPolicyNumber,
        cmiPolicyNumber: newNotifyStore.cmiPolicyNumber,
        lineReferenceId: newNotifyStore.lineReferenceId,
        appointPlace: incidentLocationRadio === 'incidentLocation' ? newNotifyStore.accidentPlace : incidentLocation,
        appointLatitude: incidentLocationRadio === 'incidentLocation' ? newNotifyStore.latitude : incidentLocationLat,
        appointLongitude: incidentLocationRadio === 'incidentLocation' ? newNotifyStore.longitude : incidentLocationLng,
        useAccidentLocation: incidentLocationRadio === 'incidentLocation' ? 'Y' : 'N',
        flagParties: newNotifyStore.flagParties,
        appointmentPlaceOther: appointmentPlaceOther
      }

      window.bizlink
        .trigger('POST', {
          payload,
          pathName
        })
        .then((response: any) => {
          console.log('addNewNotify response : ', response)
          if (!response.error) {
            console.log('addNewNotify success!!!')
            navigate('/make-claim-success', { replace: true })
          } else {
            console.log('addNewNotify not success!!!')
          }
        })
        .catch(err => {
          console.log('error', pathName, 'with', err.message)
          //setValue('errorMessage', err as string)
          setValue('errorMessage',`Error:${err.name} with ${err.message}`)
          console.log(err)
        })
    } catch (error: unknown) {
     // setValue('errorMessage', error as string)
     setValue('errorMassage', `${error}`)
     console.log('ERROR : ', error)
    }
  }

  const checkFormInput = (): boolean => {
    const { incidentLocationRadio, incidentLocation, samePositionAccident } = watch()
    if (incidentLocationRadio !== '') {
      if (incidentLocationRadio === 'newIncidentLocation' && incidentLocation !== '') return false
      else if (incidentLocationRadio === 'incidentLocation' && samePositionAccident !== '') return false
      else return true
    } else {
      return true
    }
  }

  return (
    <section id="appointment-claim-form-page" className="pt-17">
      <div className="container">
        {getValues('errorMessage') !== '' && <AlertError message={getValues('errorMessage')} />}

        <Text fontSize="24px" fontWeight="bold" className="title-screen">
          {t('viriyah.make-claim-page.claim-information.title')}
        </Text>
        <Text fontSize="16px" color="#757575">
          {t('viriyah.make-claim-page.title-alert-off')}
        </Text>

        <form id="appointment-claim-form" className="form-group" onSubmit={handleSubmit(onSubmit)}>
          <FormItem
            mt="5%"
            mb="5%"
            id="incidentLocationRadio"
            label={t('viriyah.appointment-claim-information.label-appointment-claim')}
            isError={errors.incidentLocationRadio?.message}
          >
            <RadioGroup onChange={e => setValue('incidentLocationRadio', e)}>
              <Stack spacing={8}>
                <Radio value="incidentLocation">
                  {t('viriyah.appointment-claim-information.label-incident-location')}
                </Radio>
                <FormItem
                  id="samePositionAccident"
                  select="inputGroup"
                  register={register}
                  isError={errors.incidentLocation?.message}
                  isDisabled={true}
                  IconRight={<HiLocationMarker className="icon-input-right" />}
                />
                <Radio value="newIncidentLocation" mt="5%">
                  {t('viriyah.appointment-claim-information.label-new-incident-location')}
                </Radio>
              </Stack>
            </RadioGroup>
          </FormItem>
          {watch('incidentLocationRadio') === 'newIncidentLocation' && (
            <>
              {/* ระบุตำแหน่งที่เกิดเหตุ */}
              <FormItem
                mb="5%"
                id="incidentLocation"
                label={t('viriyah.appointment-claim-information.label-appointment-claim')}
                select="googleMap"
                register={register}
                isError={errors.incidentLocation?.message}
                placeholder={t('viriyah.make-claim-page.claim-information.input-placeholder-incident-location')}
                IconRight={<HiLocationMarker className="icon-input-right-now" />}
                onChange={onOpen}
              />

              {/* ระบุจุดสังเกตของสถานที่ */}
              <FormItem
                mb="5%"
                id="incidentLandmark"
                label={t('viriyah.make-claim-page.claim-information.label-incident-landmark')}
                select="input"
                register={register}
                placeholder={t('viriyah.make-claim-page.claim-information.input-placeholder-incident-location')}
                isError={errors.incidentLandmark?.message}
              />
            </>
          )}
        </form>
        <ModalGoogleMap isOpen={isOpen} onClose={onClose} setValue={setValue} />
      </div>

      <div className="bottom-section">
        <ButtonChakra
          customBgColor="#0033A2"
          textColor="white"
          type="submit"
          isDisable={checkFormInput()}
          form="appointment-claim-form"
        >
          {t('viriyah.make-claim-page.button-submit')}
        </ButtonChakra>
      </div>
    </section>
  )
})
